module.exports = __webpack_public_path__ + "static/media/skynet.33a831e5.svg";